<template>
  <div id="app">
    <v-app id="inspire">
      <layout v-if="isLoggedIn && !isPrintLabels"></layout>
      <v-snackbar v-model="snackbar" :color="color">
        <v-layout>
          <p class="my-auto">{{ text }}</p>
          <v-spacer></v-spacer>
          <v-btn text @click="snackbar = false">
          {{ $t('message.common.close') }}
        </v-btn>
        </v-layout>
      </v-snackbar>
      <v-main v-if="!isPrintLabels" style="background: #e1edf23d;">
         <v-container fluid class="container--app">
           <router-view></router-view>
         </v-container>
      </v-main>
      <router-view v-else></router-view>
    </v-app>
  </div>
</template>

<script>
import Layout from './components/Layout'
import axios from 'axios'
import { mapGetters } from 'vuex'
import { startConnection } from '@/plugins/signalR'
export default {
  data () {
    return {
      text: '',
      snackbar: false,
      color: ''
    }
  },
  components: {
    Layout
  },
  computed: {
    ...mapGetters(['getuserDetails']),
    isLoggedIn () {
      return this.$store.state.isLoggedIn
    },
    isPrintLabels () {
      return this.$route.name === 'print_labels'
    }
  },
  created () {
    let authToken = this.$cookie.get('kilab_token')
    let user = this.$cookie.get('kilab_user') ? JSON.parse(this.$cookie.get('kilab_user')) : {}
    let authDetails = { authToken, user }
    if (authToken) {
      this.$store.commit('authLogin', authDetails)
      this.setSignalrAndNotification()
      startConnection()
    }
  },
  mounted () {
    this.$root.$on('snackbar', data => {
      this.snackbar = data.snackbar
      this.color = data.color
      this.text = data.text
    })
    this.$root.$on('setSignalrAndNotification', data => {
      this.setSignalrAndNotification()
    })

    this.$eventBus.$on('ReceiveNotification', (message, ticketId) => {
      if (this.getuserDetails.sendmailnotification) {
        let url = process.env.VUE_APP_WEB
        Notification.requestPermission().then(function (result) {
          console.log(result)
          if (result === 'granted') {
            navigator.serviceWorker.ready
              .then(function (registration) {
                registration.showNotification('kilab', {
                  icon: require('../public/images/android-icon-96x96.png'),
                  body: message,
                  vibrate: [300, 100, 400],
                  data: { url: `${url}/tickets/actions/${ticketId}` }
                })
              })
              .catch((error) => {
                console.log(error)
              })
          }
        })
      }
    })
  },
  beforeMount () {
    let text = this.$t('message.login.authFailed')
    axios.interceptors.response.use(
      (response) => {
        return Promise.resolve(response)
      },
      (error) => {
        if (error.response) {
          let exception = error.response
          if (error.response.status === 409) {
            setTimeout(() => {
              window.location.reload()
            })
          } else {
            if (error.response.data) exception = `Status Code : ${error.response.status}, Message : ${error.response.data}`
            else exception = `Status Code : ${error.response.status}, Message : ${error.response.statusText}`
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: JSON.stringify(exception) })
            if (error.response.status === 401) {
              this.$root.$emit('snackbar', { snackbar: true, color: 'error', text })
              this.$store.dispatch('logout')
              this.$router.push('/login').catch(() => {})
            }
          }
        } else {
          if (error.config.url && (!error.config.url.startsWith('https://www.brreg.no/') && !error.config.url.startsWith('https://api.bring.com/'))) {
            let text = error.message
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: JSON.stringify(text) })
          }
        }
        return Promise.reject(error)
      }
    )
  },
  methods: {
    setSignalrAndNotification () {
      Notification.requestPermission()
    }
  },
  destroyed () {
    this.$root.$off('snackbar')
    this.$root.$off('setSignalrAndNotification')
  }
}
</script>
<style>
.v-list .v-list-item--active {
  color: #036693;
}
.v-navigation-drawer .v-list .v-list-item--active {
  box-shadow: inset 7px 0px 0px #036693;
}
.dense_table .v-text-field--full-width input{
  margin-top: 0 !important;
}
.dense_table .v-text-field--full-width > .v-input__control > .v-input__slot {
  min-height: auto !important;
}
.dense_table .v-text-field.v-text-field--enclosed .v-input__append-inner {
  margin-top: 3px !important;
}
.dense_table .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
  padding: 0 !important;
  font-size: 14px;
}
.dense_table.v-data-table tbody tr:hover:not(.v-data-table__expanded__content) {
  background: none !important;
}
.v-data-table tbody tr.v-data-table__expanded__content {
  -webkit-box-shadow: inset 0px 5px 0px -5px rgba(50, 50, 50, 0.75), inset 0px 0px 8px -5px rgba(50, 50, 50, 0.75) !important;
  box-shadow: inset 0px 5px 0px -5px rgba(50, 50, 50, 0.75), inset 0px 0px 8px -5px rgba(50, 50, 50, 0.75) !important;
}
.bordered--table table, .bordered--table table thead tr, .bordered--table table tbody tr {
  border: 1px solid rgba(0,0,0,0.12);
}
.bordered--table table thead th, .bordered--table table tbody tr td {
  border-right: 1px solid rgba(0,0,0,0.12);
}
.bordered--table table thead tr {
  height: 30px;
}
.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 0px !important;
}
.participants .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot, .participants .v-text-field--full-width > .v-input__control > .v-input__slot {
  padding: 0 !important;
  min-height: 0px !important;
}
.v-application {
  font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;
}
.no-preview .v-image__image--contain, .no-preview-layout {
  filter: grayscale(100%);
  opacity: 0.66;
}
.v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td {
  height: 28px !important;
}
.container--app {
  height: 100%;
}
.expansion--panel {
  background: #036693;
  color: white;
}
::-webkit-scrollbar-track {
  background-color: #ffffff;
  border-radius: 10px;
}
::-webkit-scrollbar {
  width: 10px;
  height: 2px;
  background-color: #ffffff;
}
::-webkit-scrollbar-thumb {
  background-color: #036693;
  border-radius: 20px;
}
.compact--tree .v-treeview-node__root {
  margin: 0 !important;
}
.theme--light.v-input--is-disabled .v-label, .theme--light.v-select .v-select__selection--disabled, .theme--light.v-select.v-input--is-disabled .v-select__selections,  .theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea {
  color: #000000bf !important;
}
.alignTop {
  vertical-align: top !important;
}
.alignSub {
  vertical-align: sub !important;
}
.invoiceProducts .v-text-field {
  padding-top: 0px !important;
  margin-top: 0px !important;
}
.invoiceProducts .v-input__slot, .invoiceProducts .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
  padding-left: 6px !important;
}
.invoiceProducts .v-select__selection--comma {
  margin: 7px 4px 7px 10px !important;
}
.invoiceProducts .v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 40px !important;
}
/* data table select checkbox column width to 0 */
.select_checkbox_column_width_0 > div.v-data-table div.v-data-table__wrapper > table > thead th:first-child {
  width: 0% !important;
}
.select_checkbox_column_width_0_2ndcol > div.v-data-table div.v-data-table__wrapper > table > thead th:nth-child(2) {
  width: 0% !important;
}
/*  */
.search-hint-padding div.v-text-field__details {
  padding: 0 3px !important;
  margin-bottom: 0px !important;
}
/* Ticket attachments */
div.filename_middle_align {
  display: table;
}
div.filename_middle_align > span.caption {
  display: table-cell;
  vertical-align: middle;
}
.row {
  margin: 0px;
}
.ck-editor__editable {
  max-height: 300px;
}
.main-list thead {
  background: #f2f2f2;
}
.main-list tbody tr td,
.main-list tbody tbody tr th,
.main-list thead tr td,
.main-list thead tr th,
.main-list tfoot tr td,
.main-list tfoot tr th {
  padding: 0 8px !important;
}
.signature--pad {
  border: 1px solid #9e9e9e;
}
</style>
